import React, { useMemo } from 'react';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { Routes } from './Routing/Routes';
import { StoreManager } from './StoreManager';

import { VersionHelper } from './_helpers/VersionHelper';

import './_translations/i18n';

window.version = VersionHelper.getAppVersion();

export function WebApp({ enableLogger = true }) {
    
    const store = useMemo(() =>
        StoreManager.setUpStore(enableLogger)
    , [enableLogger]);

    if (!store)
        return null;

    return (
        <Provider store={store}>
            {/* One backend for the whole app: react-dnd allows a single
                HTML5Backend per window, so the tag inputs must not bring
                their own (two on screen threw "Cannot have two HTML5
                backends at the same time"). */}
            <DndProvider backend={HTML5Backend}>
                <Routes />
            </DndProvider>
        </Provider>
    );
};